export default __webpack_public_path__ + "static/media/psu-stidti-light.f73e07f1.ttf";